<template>
  <ElDialog
    class="modal"
    :visible.sync="showModal"
    :width="modalWidth"
  >
    <h2 class="modal__title">
      {{ title }}
    </h2>
    <div class="modal__body">
      <p class="modal__text">
        {{ text }}
      </p>

      <ElForm
        class="form"
        ref="propertyFormRef"
        :rules="rules"
        :model="requestCallForm"
      >
        <div class="form__item">
          <ElFormItem
            class="form__col"
            prop="fio"
          >
            <ElInput id="request-call-fio"
              v-model="requestCallForm.fio"
              placeholder="ФИО"
            >
              <template #prefix>
                ФИО
              </template>
            </ElInput>
          </ElFormItem>
        </div>

        <div class="form__item form__item--col">
          <ElFormItem
            class="form__col form__col--half"
            prop="phone"
          >
            <ElInput id="request-call-phone"
              v-model="requestCallForm.phone"
              placeholder="Номер телефона"
              v-mask="{regex: '^\\+7 \\([0-9]${3}\\) [0-9]${3} [0-9]${2}-[0-9]${2}'}"
              ref="phoneInput"
            >
              <template #prefix>
                Телефон
              </template>
            </ElInput>
          </ElFormItem>

          <ElFormItem
            class="form__col form__col--half"
            prop="email"
          >
            <ElInput id="request-call-email"
              v-model="requestCallForm.email"
              type="email"
              placeholder="E-mail">
              <template #prefix>
                E-mail
              </template>
            </ElInput>
          </ElFormItem>
        </div>
      </ElForm>
    </div>
    <div class="modal__submit-buttons">
      <BaseButton
        class=""
        text="Заказать"
        size="large"
        @click.native="submitHandler($refs.propertyFormRef)"
      />
    </div>
  </ElDialog>
</template>

<script>
import {getNumbersFromString, matchesEmailRegex, numbersLengthFromString} from '@/utils/string-helpers';
import { validationHandler } from '@/utils/validation';
import { PHONE_LENGTH } from '@/consts';
import modal from '@/mixins/modal';
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'ModalRequestCall',
  components: {
    BaseButton
  },
  mixins: [modal],
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    resultForm: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      rules: {
        fio: [
          { required: true, message: 'Поле ФИО обязательно для заполнения', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: 'Поле номер телефона обязательно для заполнения', trigger: 'blur' },
          {
            validator: (rule, val, resolve) => validationHandler(this.phoneLengthIsValid, `Номер телефона должен содержать ${PHONE_LENGTH} символов`, resolve),
            trigger: 'blur'
          },
        ],
        email: [
          { required: true, message: 'Поле e-mail обязательно для заполнения', trigger: 'blur' },
          {
            validator: (rule, val, resolve) => validationHandler(this.emailFormatIsValid, 'Неверный формат электронной почты!', resolve),
            trigger: 'blur'
          },
        ],
      },
      requestCallForm: {
        fio: '',
        phone: '',
        email: '',
      }
    };
  },
  computed: {
    emailFormatIsValid() {
      return matchesEmailRegex(this.requestCallForm.email);
    },
    phoneLengthIsValid() {
      return numbersLengthFromString(this.requestCallForm.phone) >= PHONE_LENGTH
    },
  },
  methods: {
    submitHandler(formEl) {
      formEl.validate(valid => {
        if (valid) {
          this.$emit('request-call-submit', this.requestCallForm);
        }
      })
    },
  },
  mounted() {
    if (this.resultForm) {
      this.requestCallForm.email = this.resultForm?.email ?? '';
      this.requestCallForm.phone = this.resultForm?.phone_number ?? '';
      this.requestCallForm.fio = this.resultForm?.management_name ?? '';
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  &__text {
    &:not(:last-child) {
      margin-bottom: rem(32);
    }
  }
}
</style>
